import React from 'react'
import { Row, Col, Form, Collapse, Input, Spin } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import DisplayText from '../_DisplayText'
import passwordValidator from 'password-validator';
import { SelectBox, InputBox, isBrowser, DatePicker } from '../../../../shared/custom-ant-d'
import { DatePicker as DatePickerBV } from 'antd';
import moment from 'moment';

const { Panel } = Collapse;
const schema = new passwordValidator();

export const USA = (props) => {
  const { months, onMonthChanged, daysOfMonth } = props;

  
  
  const isFEMA = props.jobDetails?.profitCenterName === 'FEMA' || 
                 props.jobDetails?.profitcentername === 'FEMA' ||
                 props.jobDetails?.reqProfitCenterName === 'FEMA' ||
                 props.jobDetails?.ReqProfitCenterName === 'FEMA';
  
  
  // Render FEMA template
  const renderFEMATemplate = () => {
    return (
      <>
        
        <section id="employment-info">
        <Collapse defaultActiveKey={['1']} expandIconPosition={'right'}>
          <Panel header="Voluntary Pre-Employment Information" key="1">
            <Row>
              <Col md={{ span: 24 }} xs={24}>
                <DisplayText
                    text={props.getDisplayText('VOLUNTARY PRE-EMPLOYMENT INFO','Diversity Statement')}
                  mode='ellipsis'
                />
              </Col>
            </Row><br />
            <Row align='bottom'>
              <Col md={{ span: 11 }} xs={24}>
                <Form.Item
                  label={<b>{DisplayText(
                    {
                      mode: 'label',
                      text: props.getDisplayText('VOLUNTARY PRE-EMPLOYMENT INFO','Diversity Question 1'),
                    }
                  )}</b>}
                  name="ethnicityID"
                  initialValue={null}
                >
                  <SelectBox
                    data={
                      props.ethnicityList && (
                        props.ethnicityList.map((item, i) => {
                          return ({ value: item.codeValueID, label: item.codeValueDescription })
                        })
                      )
                    }
                    label={''}
                    onChange={(value) => {
                      props.resetFieldValues({ ethnicityID: value })
                    }}
                    onDismiss={(value) => {
                      props.resetFieldValues({ ethnicityID: value })
                    }} />
                </Form.Item>
              </Col>
              <Col md={{ span: 11, offset: 1 }} xs={24}>
                <Form.Item
                  label={<b>{DisplayText(
                    {
                      mode: 'label',
                      text: props.getDisplayText('VOLUNTARY PRE-EMPLOYMENT INFO','Diversity Question 2'),
                    }
                  )}</b>}
                  name="raceID"
                  initialValue={null}
                >
                  <SelectBox
                    data={
                      props.raceList && (
                        props.raceList.map((item, i) => {
                          return ({ value: item.codeValueID, label: item.codeValueDescription })
                        })
                      )
                    }
                    label={''}
                    onChange={(value) => {
                      props.resetFieldValues({ raceID: value })
                    }}
                    onDismiss={(value) => {
                      props.resetFieldValues({ raceID: value })
                    }} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 24 }}>
                <DisplayText
                  text={props.getDisplayText('VOLUNTARY PRE-EMPLOYMENT INFO','Ethnicity Statement')}
                  mode='ellipsis'
                />
              </Col>
            </Row><br />
            {/*<Row>*/}
            {/*  <Col md={{ span: 11 }} xs={22}>*/}
            {/*    <Form.Item*/}
            {/*      name="gender"*/}
            {/*      label={<b>{DisplayText(*/}
            {/*        {*/}
            {/*          mode: 'label',*/}
            {/*          text: props.getDisplayText('VOLUNTARY PRE-EMPLOYMENT INFO','Gender Question'),*/}
            {/*        }*/}
            {/*      )}</b>}*/}

            {/*      initialValue={''}>*/}
            {/*      <SelectBox*/}
            {/*        data={*/}
            {/*          props.genderList && (*/}
            {/*            props.genderList.map((item, i) => {*/}
            {/*              return ({ value: item.expText, label: item.expText })*/}
            {/*            })*/}
            {/*          )*/}
            {/*        }*/}
            {/*        label={''}*/}
            {/*        onChange={(value) => {*/}
            {/*          props.resetFieldValues({ gender: value })*/}
            {/*        }}*/}
            {/*        onDismiss={(value) => {*/}
            {/*          props.resetFieldValues({ gender: value })*/}
            {/*        }} />*/}
            {/*    </Form.Item>*/}
            {/*  </Col>*/}
            {/*</Row>*/}
          </Panel>
        </Collapse>
      </section>
      <section id='agreement-statement'>
        <Collapse defaultActiveKey={['2', '3', '4', '5', '6', '7']} expandIconPosition={'right'}>
          <Panel header="Voluntary Veteran Group Self-Identification" key="2">
            <Row>
              <Col md={{ span: 24 }}>
                <DisplayText
                  text={props.getDisplayText('VOLUNTARY VETERAN GROUP SELF-IDENTIFICATION','Veteran Statement 1')}
                  mode='ellipsis'
                  maxLine='6'
                />
              </Col>
            </Row><br />
            <Row>
              <Col md={{ span: 11 }} xs={22}>
                <Form.Item
                  label={<b>Veteran:</b>}
                  name="veteranID"
                  initialValue={null}
                >
                  <SelectBox
                    data={
                      props.veteranList && (
                        props.veteranList.map((item, i) => {
                          return ({ value: item.codeValueID, label: item.codeValueDescription })
                        })
                      )
                    }
                    label={''}
                    onChange={(value) => {
                      props.resetFieldValues({ veteranID: value })
                    }}
                    onDismiss={(value) => {
                      props.resetFieldValues({ veteranID: value })
                    }} />
                </Form.Item>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={{ span: 24 }} xs={24}>
                <DisplayText
                  text={props.getDisplayText('VOLUNTARY VETERAN GROUP SELF-IDENTIFICATION','Veteran Statement 2')}
                  mode='ellipsis'
                />
              </Col>
            </Row>
          </Panel>
          <Panel header="Voluntary Self-Identification of Disability" key="3">
            <Row>
              <Col md={{ span: 24 }} xs={24}>
                <DisplayText
                  text={props.getDisplayText('Disability','Disability Statement 1')}
                  mode='ellipsis'
                />
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 24 }} xs={24}>
                <DisplayText
                  text={props.getDisplayText('Disability','Disability Statement 2')}
                  mode='ellipsis'
                /><br />
                <DisplayText
                  text={props.getDisplayText('Disability','Disability Statement 3')}
                  mode='ellipsis'
                  maxLine='3'
                />
              </Col>
            </Row><br />
            <Row>
              <Col md={{ span: 11 }} xs={22}>
                <Form.Item
                  label={<b>Disabled Person:</b>}
                  name="disabilityID"
                  initialValue={''}
                >
                  <SelectBox
                    data={
                      props.disabilityStatusList && (
                        props.disabilityStatusList.map((item, i) => {
                          return ({ value: item.codeValueID, label: item.codeValueDescription })
                        })
                      )
                    }
                    label={''}
                    onChange={(value) => {
                      props.resetFieldValues({ disabilityID: value })
                    }}
                    onDismiss={(value) => {
                      props.resetFieldValues({ disabilityID: value })
                    }} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 24 }} xs={24}>
                <DisplayText
                  text={props.getDisplayText('Disability','Disability Statement 4')}
                />
                <DisplayText
                  text={props.getDisplayText('Disability','Disability Statement 5')}
                  mode='ellipsis'
                  maxLine='3'
                />
              </Col>
            </Row>
          </Panel>
          <Panel header="Notice to California Job Applicants Regarding The Collection of Personal Information" key="4">
            <Row>
              <Col md={{ span: 24 }} xs={24}>
                <DisplayText
                  text={props.getDisplayText('California Applicants','California Applicant Statement')}
                  mode='ellipsis'
                  maxLine='6'
                /><br />
                <DisplayText
                  text={props.getDisplayText('California Applicants','California Applicant Question')}
                  isRequired={true}
                />
              </Col>
            </Row><br />
            <Row>
              <Col md={{ span: 11 }} xs={22}>
                <Form.Item
                  name="californiaPrivacyNoticeAgreeInd"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'This is a required field.'
                    }
                  ]}
                  initialValue={''}
                >
                  <SelectBox
                    data={
                      [
                        { value: 'true', label: 'I Agree' },
                        { value: 'false', label: 'I am not a California resident' },
                      ]
                    }
                    label={''}
                    onChange={(value) => {
                      props.resetFieldValues({ californiaPrivacyNoticeAgreeInd: value })
                    }}
                    onDismiss={(value) => {
                      props.resetFieldValues({ californiaPrivacyNoticeAgreeInd: value })
                    }} />
                </Form.Item>
              </Col>
            </Row>
          </Panel>
          <Panel header="Mutual Agreement to Arbitrate Employment-Related Claims" key="5">
            <Row>
              <Col md={{ span: 24 }} xs={24}>
                <DisplayText
                  text={props.getDisplayText('Arbitration','Arbitration Statement 1')}
                  mode='ellipsis'
                />
              </Col>
            </Row>
          </Panel>
          <Panel header="Arbitration Agreement" key="6">
              <Row>
                <Col md={{ span: 24 }} xs={24}>
                  <DisplayText
                    text={props.getDisplayText('Arbitration', 'Arbitration Statement FEMA')}
                  />
                </Col>
              </Row>
              <br />
              <Row>
              <Col md={{ span: 24 }} xs={24}>
                <DisplayText
                  text={props.getDisplayText('Arbitration','Arbitration Statement 3')}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={{ span: 11 }} xs={24}>
                <Form.Item
                  label={<b>{DisplayText(
                    {
                      mode: 'label',
                      text: props.getDisplayText('Arbitration','Arbitration Question'),
                    }
                  )}</b>}
                  name="arbitrationAgreeInd"
                  initialValue={''}
                  rules={[
                    {
                      required: true,
                      message: 'Do you agree with the Arbitration Statement above? is required.',
                    }
                  ]}
                >
                  <SelectBox
                    data={
                      [
                        { value: 'true', label: 'I Agree' }
                      ]
                    }
                    label={''}
                    onChange={(value) => {
                      props.resetFieldValues({ arbitrationAgreeInd: value })
                    }}
                    onDismiss={(value) => {
                      props.resetFieldValues({ arbitrationAgreeInd: value })
                    }} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 24 }} xs={24}>
                <DisplayText
                    text={props.getDisplayText('Employment Verification','Employment Verification Text FEMA')}
                />
              </Col>
            </Row><br />
            <Row align='bottom'>
              <Col md={{ span: 11 }} xs={24}>
                <Form.Item
                  label={<b>{DisplayText(
                    {
                      mode: 'label',
                      text: props.getDisplayText('Employment Verification', 'SSN Question FEMA'),
                    }
                  )}</b>}
                  name="socialSecurityNumber"
                  rules={[
                    { required: true, message: 'Please provide your Social Security Number (XXX-XX-XXXX) is required' },
                    () => ({
                      validator(_, value) {
                        var regex = /^[\d]{3}-[\d]{2}-[\d]{4}$/;
                        if (regex.test(value)) {
                          return Promise.resolve();
                        }
                        else {
                          return Promise.reject('Invalid format. Use format XXX-XX-XXXX.')
                        }
                      }
                    }),
                  ]}
                >
                  <Input />
                  {/*{(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}*/}
                </Form.Item>
              </Col>
              <Col md={{ span: 11, offset: 1 }} xs={24}>
                <Form.Item
                  label={<b>{DisplayText(
                    {
                      mode: 'label',
                      text: props.getDisplayText('Employment Verification', 'DOB Question FEMA'),
                    }
                  )}</b>}
                  name="dateOfBirthFull"
                  initialValue={''}
                  rules={[
                    {
                      required: true, message: 'Date of Birth is required'
                    },
                    () => ({
                      validator(_, value) {
                        var now = moment(new Date()); //todays date
                        var end = moment(value); // another date
                        var duration = moment.duration(now.diff(end));
                        var years = duration.asYears();
                        if (years >= 18) {
                          return Promise.resolve();
                        }
                        else {
                          return Promise.reject('You must be 18 years or older to be hired.')
                        }
                      }
                    }),
                  ]}
                >
                  {
                    (isBrowser) ?
                      (
                        <DatePickerBV
                          
                          format={'MM/DD/YYYY'}
                          label={''}
                        />
                      ) :
                      (
                        <DatePicker
                          
                          label={''}
                        />
                      )
                  }
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 11 }} xs={24}>
                <Form.Item
                  name="gender"
                  rules={[
                    { required: true, message: 'Gender is required' }
                  ]}
                  label={<b>{DisplayText(
                    {
                      mode: 'label',
                      text: props.getDisplayText('Employment Verification', 'Gender Question FEMA'),
                    }
                  )}</b>}
                  initialValue={''}>
                  <SelectBox
                    data={
                      props.genderList && (
                        props.genderList.map((item, i) => {
                          return ({ value: item.expText, label: item.expText })
                        })
                      )
                    }
                    label={''}
                    onChange={(value) => {
                      props.resetFieldValues({ gender: value })
                    }}
                    onDismiss={(value) => {
                      props.resetFieldValues({ gender: value })
                    }} />
                </Form.Item>
              </Col>
              <Col md={{ span: 11, offset: 1 }} xs={24}>
                <Form.Item
                  label={<b>{DisplayText(
                    {
                      mode: 'label',
                      text: props.getDisplayText('Employment Verification', 'BirthCity Question FEMA'),
                    }
                  )}</b>}
                  name="birthCity"
                  rules={[
                    { required: true, message: 'Name of your Birth City is required' }
                  ]}
                >
                  <Input />
                  {/*{(isBrowser) ? (<Input disabled={disableAll} />) : (<InputBox disabled={disableAll} />)}*/}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 11 }} xs={24}>
                <Form.Item
                  label={<b>{DisplayText(
                    {
                      mode: 'label',
                      text: props.getDisplayText('Employment Verification', 'BirthState Question FEMA'),
                    }
                  )}</b>}
                  name="birthState"
                  rules={[
                    { required: true, message: 'Name of your Birth State is required' }
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col md={{ span: 11, offset: 1 }} xs={24}>
                <Form.Item
                  name="birthCountry"
                  rules={[
                    { required: true, message: 'Name of your Birth Country is required' }
                  ]}
                  label={<b>{DisplayText(
                    {
                      mode: 'label',
                      text: props.getDisplayText('Employment Verification', 'BirthCountry Question FEMA'),
                    }
                  )}</b>}
                  initialValue={''}>
                  <SelectBox
                    data={
                      props.allCountryList && (
                        props.allCountryList.map((item, i) => {
                          return ({ value: item.countryName, label: item.countryName })
                        })
                      )
                    }
                    showSearch={true}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    notFoundContent={!props.allCountryList ? <Spin size="small" /> : null}
                    label={''}
                    onChange={(value) => {
                      props.resetFieldValues({ birthCountry: value })
                    }}
                    onDismiss={(value) => {
                      props.resetFieldValues({ birthCountry: value })
                    }} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 11 }} xs={24}>
                <Form.Item
                  name="citizenshipCountry"
                  rules={[
                    { required: true, message: 'Name of your Country of Citizenship is required' }
                  ]}
                  label={<b>{DisplayText(
                    {
                      mode: 'label',
                      text: props.getDisplayText('Employment Verification', 'Citizenship Question FEMA'),
                    }
                  )}</b>}
                  initialValue={''}>
                  <SelectBox
                    data={
                      props.allCountryList && (
                        props.allCountryList.map((item, i) => {
                          return ({ value: item.countryName, label: item.countryName })
                        })
                      )
                    }
                    showSearch={true}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    notFoundContent={!props.allCountryList ? <Spin size="small" /> : null}
                    label={''}
                    onChange={(value) => {
                      props.resetFieldValues({ citizenshipCountry: value })
                    }}
                    onDismiss={(value) => {
                      props.resetFieldValues({ citizenshipCountry: value })
                    }} />
                </Form.Item>
              </Col>
            </Row>
          </Panel>
          <Panel header="Applicant Statement" key="7">
            <Row>
              <Col md={{ span: 24 }} xs={24}>
                <DisplayText
                  text={props.getDisplayText('Applicant Statement','USA Applicant Statement')}
                  mode='ellipsis'
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={{ span: 11 }} xs={24}>
                <Form.Item
                  label={<b>Do you agree with the above Applicant Statement?</b>}
                  name="applicantStatementAgreeInd"
                  rules={[
                    {
                      required: true,
                      message: 'This field is required.',
                    }
                  ]}
                  initialValue={''}
                >
                  <SelectBox
                    data={
                      [
                        { value: 'true', label: 'I Agree' }
                      ]
                    }
                    label={''}
                    onChange={(value) => {
                      props.resetFieldValues({ applicantStatementAgreeInd: value })
                    }}
                    onDismiss={(value) => {
                      props.resetFieldValues({ applicantStatementAgreeInd: value })
                    }} />
                </Form.Item>
              </Col>
              <Col md={{ span: 11, offset: 1 }} xs={24}>
                <Form.Item
                  label={<b>Please type your full name to sign this application:</b>}
                  name="applicantSignature"
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    }
                  ]}
                  initialValue={''}
                >
                  {
                    (isBrowser) ?
                      (<Input />) :
                      (<InputBox />)
                  }
                </Form.Item>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      </section>
    </>
    );
  };

  // Render Non-FEMA template
  const renderNonFEMATemplate = () => {
    return (
      <>
        
        <section id="employment-info">
          <Collapse defaultActiveKey={['1']} expandIconPosition={'right'}>
            <Panel header="Voluntary Pre-Employment Information" key="1">
              <Row>
                <Col md={{ span: 24 }} xs={24}>
                  <DisplayText
                    text={props.getDisplayText('VOLUNTARY PRE-EMPLOYMENT INFO','Diversity Statement')}
                    mode='ellipsis'
                  />
                </Col>
              </Row><br />
              <Row align='bottom'>
                <Col md={{ span: 11 }} xs={24}>
                  <Form.Item
                    label={<b>{DisplayText(
                      {
                        mode: 'label',
                        text: props.getDisplayText('VOLUNTARY PRE-EMPLOYMENT INFO','Diversity Question 1'),
                      }
                    )}</b>}
                    name="ethnicityID"
                    initialValue={null}
                  >
                    <SelectBox
                      data={
                        props.ethnicityList && (
                          props.ethnicityList.map((item, i) => {
                            return ({ value: item.codeValueID, label: item.codeValueDescription })
                          })
                        )
                      }
                      label={''}
                      onChange={(value) => {
                        props.resetFieldValues({ ethnicityID: value })
                      }}
                      onDismiss={(value) => {
                        props.resetFieldValues({ ethnicityID: value })
                      }} />
                  </Form.Item>
                </Col>
                <Col md={{ span: 11, offset: 1 }} xs={24}>
                  <Form.Item
                    label={<b>{DisplayText(
                      {
                        mode: 'label',
                        text: props.getDisplayText('VOLUNTARY PRE-EMPLOYMENT INFO','Diversity Question 2'),
                      }
                    )}</b>}
                    name="raceID"
                    initialValue={null}
                  >
                    <SelectBox
                      data={
                        props.raceList && (
                          props.raceList.map((item, i) => {
                            return ({ value: item.codeValueID, label: item.codeValueDescription })
                          })
                        )
                      }
                      label={''}
                      onChange={(value) => {
                        props.resetFieldValues({ raceID: value })
                      }}
                      onDismiss={(value) => {
                        props.resetFieldValues({ raceID: value })
                      }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col md={{ span: 24 }}>
                  <DisplayText
                    text={props.getDisplayText('VOLUNTARY PRE-EMPLOYMENT INFO','Ethnicity Statement')}
                    mode='ellipsis'
                  />
                </Col>
              </Row><br />
              <Row>
                <Col md={{ span: 11 }} xs={22}>
                  <Form.Item
                    name="gender"
                    label={<b>{DisplayText(
                      {
                        mode: 'label',
                        text: props.getDisplayText('VOLUNTARY PRE-EMPLOYMENT INFO','Gender Question'),
                      }
                    )}</b>}

                    initialValue={''}>
                    <SelectBox
                      data={
                        props.genderList && (
                          props.genderList.map((item, i) => {
                            return ({ value: item.expText, label: item.expText })
                          })
                        )
                      }
                      label={''}
                      onChange={(value) => {
                        props.resetFieldValues({ gender: value })
                      }}
                      onDismiss={(value) => {
                        props.resetFieldValues({ gender: value })
                      }} />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>
        </section>
        <section id='agreement-statement'>
          <Collapse defaultActiveKey={['2', '3', '4', '5', '6', '7']} expandIconPosition={'right'}>
            <Panel header="Voluntary Veteran Group Self-Identification" key="2">
              <Row>
                <Col md={{ span: 24 }}>
                  <DisplayText
                    text={props.getDisplayText('VOLUNTARY VETERAN GROUP SELF-IDENTIFICATION','Veteran Statement 1')}
                    mode='ellipsis'
                    maxLine='6'
                  />
                </Col>
              </Row><br />
              <Row>
                <Col md={{ span: 11 }} xs={22}>
                  <Form.Item
                    label={<b>Veteran:</b>}
                    name="veteranID"
                    initialValue={null}
                  >
                    <SelectBox
                      data={
                        props.veteranList && (
                          props.veteranList.map((item, i) => {
                            return ({ value: item.codeValueID, label: item.codeValueDescription })
                          })
                        )
                      }
                      label={''}
                      onChange={(value) => {
                        props.resetFieldValues({ veteranID: value })
                      }}
                      onDismiss={(value) => {
                        props.resetFieldValues({ veteranID: value })
                      }} />
                  </Form.Item>
                </Col>
              </Row>
              <br />
              <Row>
                <Col md={{ span: 24 }} xs={24}>
                  <DisplayText
                    text={props.getDisplayText('VOLUNTARY VETERAN GROUP SELF-IDENTIFICATION','Veteran Statement 2')}
                    mode='ellipsis'
                  />
                </Col>
              </Row>
            </Panel>
            <Panel header="Voluntary Self-Identification of Disability" key="3">
              <Row>
                <Col md={{ span: 24 }} xs={24}>
                  <DisplayText
                    text={props.getDisplayText('Disability','Disability Statement 1')}
                    mode='ellipsis'
                  />
                </Col>
              </Row>
              <Row>
                <Col md={{ span: 24 }} xs={24}>
                  <DisplayText
                    text={props.getDisplayText('Disability','Disability Statement 2')}
                    mode='ellipsis'
                  /><br />
                  <DisplayText
                    text={props.getDisplayText('Disability','Disability Statement 3')}
                    mode='ellipsis'
                    maxLine='3'
                  />
                </Col>
              </Row><br />
              <Row>
                <Col md={{ span: 11 }} xs={22}>
                  <Form.Item
                    label={<b>Disabled Person:</b>}
                    name="disabilityID"
                    initialValue={''}
                  >
                    <SelectBox
                      data={
                        props.disabilityStatusList && (
                          props.disabilityStatusList.map((item, i) => {
                            return ({ value: item.codeValueID, label: item.codeValueDescription })
                          })
                        )
                      }
                      label={''}
                      onChange={(value) => {
                        props.resetFieldValues({ disabilityID: value })
                      }}
                      onDismiss={(value) => {
                        props.resetFieldValues({ disabilityID: value })
                      }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col md={{ span: 24 }} xs={24}>
                  <DisplayText
                    text={props.getDisplayText('Disability','Disability Statement 4')}
                  />
                  <DisplayText
                    text={props.getDisplayText('Disability','Disability Statement 5')}
                    mode='ellipsis'
                    maxLine='3'
                  />
                </Col>
              </Row>
            </Panel>
            <Panel header="Notice to California Job Applicants Regarding The Collection of Personal Information" key="4">
              <Row>
                <Col md={{ span: 24 }} xs={24}>
                  <DisplayText
                    text={props.getDisplayText('California Applicants','California Applicant Statement')}
                    mode='ellipsis'
                    maxLine='6'
                  /><br />
                  <DisplayText
                    text={props.getDisplayText('California Applicants','California Applicant Question')}
                    isRequired={true}
                  />
                </Col>
              </Row><br />
              <Row>
                <Col md={{ span: 11 }} xs={22}>
                  <Form.Item
                    name="californiaPrivacyNoticeAgreeInd"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: 'This is a required field.'
                      }
                    ]}
                    initialValue={''}
                  >
                    <SelectBox
                      data={
                        [
                          { value: 'true', label: 'I Agree' },
                          { value: 'false', label: 'I am not a California resident' },
                        ]
                      }
                      label={''}
                      onChange={(value) => {
                        props.resetFieldValues({ californiaPrivacyNoticeAgreeInd: value })
                      }}
                      onDismiss={(value) => {
                        props.resetFieldValues({ californiaPrivacyNoticeAgreeInd: value })
                      }} />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
            <Panel header="Mutual Agreement to Arbitrate Employment-Related Claims" key="5">
              <Row>
                <Col md={{ span: 24 }} xs={24}>
                  <DisplayText
                    text={props.getDisplayText('Arbitration','Arbitration Statement 1')}
                    mode='ellipsis'
                  />
                </Col>
              </Row>
            </Panel>
            <Panel header="Arbitration Agreement" key="6">
              <Row>
                <Col md={{ span: 24 }} xs={24}>
                  <DisplayText
                    text={props.getDisplayText('Arbitration','Arbitration Statement 3')}
                  />
                </Col>
              </Row>
              <br />
              <Row>
                <Col md={{ span: 11 }} xs={24}>
                  <Form.Item
                    label={<b>{DisplayText(
                      {
                        mode: 'label',
                        text: props.getDisplayText('Arbitration','Arbitration Question'),
                      }
                    )}</b>}
                    name="arbitrationAgreeInd"
                    initialValue={''}
                    rules={[
                      {
                        required: true,
                        message: 'Do you agree with the Arbitration Statement above? is required.',
                      }
                    ]}
                  >
                    <SelectBox
                      data={
                        [
                          { value: 'true', label: 'I Agree' }
                        ]
                      }
                      label={''}
                      onChange={(value) => {
                        props.resetFieldValues({ arbitrationAgreeInd: value })
                      }}
                      onDismiss={(value) => {
                        props.resetFieldValues({ arbitrationAgreeInd: value })
                      }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col md={{ span: 24 }} xs={24}>
                  <DisplayText
                    text={props.getDisplayText('Employment Verification','Employment Verification Text')}
                  />
                </Col>
              </Row><br />
              <Row align='bottom'>
                <Col md={{ span: 8 }} xs={24}>
                  <Form.Item
                    label={<b>{DisplayText(
                      {
                        mode: 'label',
                        text: props.getDisplayText('Employment Verification','SSN Question'),
                      }
                    )}</b>}
                    name="ssnLastFourDigits"
                    initialValue={null}
                    rules={[
                      {
                        required: true,
                        message: 'Please provide Last 4 digits of your Social Security Number (XXXX) is required',
                      },
                      {
                        len: 4,
                        message: "Social Security Number must contain 4 digits."
                      },
                      () => ({
                        validator(_, value) {
                          schema
                            .is().not().letters()
                            .is().not().symbols();

                          if (!schema.validate(value, { list: true }).includes('letters') && !schema.validate(value, { list: true }).includes('symbols')) {
                            return Promise.resolve();
                          } else {
                            return Promise.reject('Mobile number must contain numbers only.')
                          }
                        }
                      }),
                    ]}
                  >
                    {
                      (isBrowser) ?
                        (<Input.Password />) :
                        (
                          <InputBox
                            type={'password'}
                            placeholder="Last 4 digits SSN"
                            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                          />
                        )
                    }
                  </Form.Item>
                </Col>
                <Col md={{ span: 11, offset: 1 }} xs={24}>
                  <Form.Item
                    label={<b>{DisplayText(
                      {
                        mode: 'label',
                        text: props.getDisplayText('Employment Verification','Month Question'),
                      }
                    )}</b>}
                    name="monthOfBirth"
                    initialValue={''}
                    rules={[
                      {
                        required: true,
                        message: 'Please provide your Month of birth is required',
                      }
                    ]}
                  >
                    <SelectBox
                      data={
                        months && (
                          months.map((item, i) => {
                            return (
                              { value: item, label: item }
                            );
                          })
                        )
                      }
                      label={''}
                      onChange={(value) => {
                        props.resetFieldValues({ monthOfBirth: value })
                        onMonthChanged(value)
                      }}
                      onDismiss={(value) => {
                        props.resetFieldValues({ monthOfBirth: value })
                      }} />
                  </Form.Item>
                </Col>
                <Col md={{ span: 8 }} xs={24}>
                  <Form.Item
                    label={<b>{DisplayText(
                      {
                        mode: 'label',
                        text: props.getDisplayText('Employment Verification','Day Question'),
                      }
                    )}</b>}
                    name="dayOfBirth"
                    rules={[
                      {
                        required: true,
                        message: 'Day of birth is required',
                      }
                    ]}
                    initialValue={''}
                  >
                    <SelectBox
                      data={
                        daysOfMonth && (
                          daysOfMonth.map((item, i) => {
                            return (
                              { value: item, label: item }
                            );
                          })
                        )
                      }
                      label={''}
                      onChange={(value) => {
                        props.resetFieldValues({ dayOfBirth: value })
                      }}
                      onDismiss={(value) => {
                        props.resetFieldValues({ dayOfBirth: value })
                      }} />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
            <Panel header="Applicant Statement" key="7">
              <Row>
                <Col md={{ span: 24 }} xs={24}>
                  <DisplayText
                    text={props.getDisplayText('Applicant Statement','USA Applicant Statement')}
                    mode='ellipsis'
                  />
                </Col>
              </Row>
              <br />
              <Row>
                <Col md={{ span: 11 }} xs={24}>
                  <Form.Item
                    label={<b>Do you agree with the above Applicant Statement?</b>}
                    name="applicantStatementAgreeInd"
                    rules={[
                      {
                        required: true,
                        message: 'This field is required.',
                      }
                    ]}
                    initialValue={''}
                  >
                    <SelectBox
                      data={
                        [
                          { value: 'true', label: 'I Agree' }
                        ]
                      }
                      label={''}
                      onChange={(value) => {
                        props.resetFieldValues({ applicantStatementAgreeInd: value })
                      }}
                      onDismiss={(value) => {
                        props.resetFieldValues({ applicantStatementAgreeInd: value })
                      }} />
                  </Form.Item>
                </Col>
                <Col md={{ span: 11, offset: 1 }} xs={24}>
                  <Form.Item
                    label={<b>Please type your full name to sign this application:</b>}
                    name="applicantSignature"
                    rules={[
                      {
                        required: true,
                        message: 'This field is required',
                      }
                    ]}
                    initialValue={''}
                  >
                    {
                      (isBrowser) ?
                        (<Input />) :
                        (<InputBox />)
                    }
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>
        </section>
      </>
    );
  };

  // Return the appropriate template based on profit center
  return isFEMA ? renderFEMATemplate() : renderNonFEMATemplate();
}
